import { Button } from '@mui/material'
import { useState } from 'react'
import { NewGroupDialog } from './components/NewGroupDialog/NewGroupDialog'
import { GroupTableComponent } from './components/GroupTableComponent/GroupTableComponent'

export const GroupManagementComponent = () => {
  const [selectedGroup, setSelectedGroup] = useState(null)
  const [isOpenNewGroupDialog, setIsOpenNewGroupDialog] = useState(false)

  const closeDialog = (isOpenSnackbar = false) => {
    if (isOpenSnackbar) {
      setTimeout(() => {
        setIsOpenNewGroupDialog(false)
      }, 2000);
    } else {
      setIsOpenNewGroupDialog(false)
    }
  }
  
  return (
    <div>
      <GroupTableComponent
        isOpenNewGroupDialog={isOpenNewGroupDialog}
        setSelectedGroup={(group) => {
          setSelectedGroup(group)
          setIsOpenNewGroupDialog(true)
        }}
      />
      {/* <div className="mt-10">
        <Button variant="contained" onClick={() => setIsOpenNewGroupDialog(true)}>
          Create private group
        </Button>
      </div> */}
      {/* <NewGroupDialog
        selectedGroup={selectedGroup}
        clearSelectedGroup={() => setSelectedGroup(null)}
        isOpen={isOpenNewGroupDialog}
        handleCloseNewGroupDialog={closeDialog}
      /> */}
    </div>
  )
}